import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import AurButton from '../aur-button/AurButton';
import {ReactComponent as PlusIcon} from '../../../assests/svg/plus-icon.svg';
import { t } from 'i18next';
import { Permission } from '../../../types/permission-group/permission';
import { ECA_PERMISSION_CODES_CONSTANTS } from '../../../constants/constants';


interface AurECAPermissionProps {
  onAddPermission: () => void;
  onUpdatePermission: () => void;
  permissions?: Permission[];
}

const AurECAPermissionStatus: React.FC<AurECAPermissionProps> = ({ onAddPermission, permissions = [], onUpdatePermission }) => {
  const [permissionSubTitle, setPermissionSubTitle] = useState('');
  useEffect(() => {
    setPermissionSubTitle(getSubTitle());
  }, [permissions])
  const getSubTitle = () => {
    if (permissions?.length < 1) {
      return t('eca.permissionMessages.noPermission');
    } else {
      return t('eca.permissionMessages.withDynamicPermission', {
        ECAAdmin: permissions?.some(permission => permission.permissionCode === ECA_PERMISSION_CODES_CONSTANTS.ECA_ADMIN_ONEOF) ? t('eca.permissionMessages.admin') : t('eca.permissionMessages.nonAdmin'),
        documentSummary: permissions?.some(permission => permission.permissionCode === ECA_PERMISSION_CODES_CONSTANTS.ECA_CREATE_DOCUMENT) ? t('eca.permissionMessages.documentSummary') : '.',
      });
    }
  }

  return (
    <Box className="aur-eca-permission">
      <div className='aur-eca-permission-title'>
        <Typography className='typo-text subhead3_size'>
          {t('eca.permissionMessages.ecaEnabledTitle')} 
        </Typography>
      </div>
      <div className='aur-eca-permission-subtitle'>
        <Typography className='typo-text body2_size'>
          {permissionSubTitle}
        </Typography>
        
          { permissions && permissions.length > 0 && 
        <AurButton classNames='permission-button'
          type='text'
          size='Small'
          onClick={onUpdatePermission}
          dataTestId={t('eca.permissionMessages.changePermission')}
          label={t('eca.permissionMessages.changePermission')}
          ariaLabel={t('eca.permissionMessages.changePermission')}
          /> 
        }
      </div>
      {
        permissions && permissions.length < 1 && 
        <div className='aur-eca-permission-button'>
          <AurButton
            type='continue'
            size='Small'
            startIcon={<PlusIcon aria-hidden="true" />}
            onClick={onAddPermission}
            dataTestId={t('eca.permissionMessages.addPermissions')}
            label={t('eca.permissionMessages.addPermissions')}
            ariaLabel={t('eca.permissionMessages.addPermissions')}
            /> 
        </div>
      }
      
    </Box>
  );
};

export default AurECAPermissionStatus;
